export enum FileType {
  YAML,
  URDF,
}
